// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"1db3cb97","977":"a53a6141"}[chunkId] + ".chunk.js";
};